import initCosmosParallax from './scroll-creator';
import initFadeOut from './fade-out';
import animations from './animations';
import forms from './forms';
import code from './code';
import lazyLoad from './lazy';

export {
  lazyLoad,
  initCosmosParallax,
  initFadeOut,
  animations,
  forms,
  code
};



// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/modules/index.js